export const MicrophoneStatus = {
  Normal: 0x000,
  Preflight: 0x001,
  Available: 0x002,
  Listensing: 0x004,
  Speeching: 0x008,
  Ended: 0x0010,
  NotAllowed: 0x020,
  NotFound: 0x040,
  Invalid: 0x080,
  Error: 0x100,
  NotSupported: 0x200,
};
